<template>
  <div class="app">
    <Card dis-hover>
	  <Form ref="queryForm" :label-width="70" label-position="left" inline>
	      <Row :gutter="16">
	          <Col span="4">
				  
	             <FormItem label="岗位：" :label-width="70" >
				   <Select placeholder="请选择岗位"  style="width: 160px" v-model="form.Post">
				     <Option value="">------</Option>
				     <Option v-for="item in postList" :key="item.value" :value="item.value">{{ item.name }}</Option>
				   </Select>
	             </FormItem>
	          </Col>
			  <Col span="4">
			      <FormItem label="年份:" :label-width="50" style="width: 100%">
			         <DatePicker
			           type="year"
			           @on-change="(fmtDate,date)=>{changeDate(fmtDate,date,'year')}"
			           :value="form.year"
			           placeholder="请选择"
			           :editable="false"
			           style="width:180px; padding-right:20px;"
			         ></DatePicker>
			      </FormItem>
			  </Col>
			  <Col span="4">
			      <FormItem label="月份:" :label-width="50" style="width: 100%">
			         <DatePicker
			           type="month"
			           @on-change="(fmtDate,date)=>{changeDate(fmtDate,date,'month')}"
			           :value="form.month"
			  					   format="MM"
			           placeholder="请选择"
			           :editable="false"
			           style="width:180px; padding-right:20px;"
			         ></DatePicker>
			      </FormItem>
			  </Col>
	          <Button icon="ios-search" type="primary" size="default" @click="getData" class="toolbar-btn">查询</Button>
	          <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
			  <Button type="success" icon="md-archive" @click="importT" class="toolbar-btn">导入</Button>&nbsp;&nbsp;
			  <Button icon="md-archive" type="primary" size="default" @click="shoImport" class="toolbar-btn">下载导入模板</Button>
			  <Button type="success" v-show="isAdmin" icon="md-archive" @click="deleteImport" class="toolbar-btn">清空</Button>&nbsp;&nbsp;
			 <!-- <Upload :before-upload="beforeImportFile" :on-success="importFile" :on-error="errorImportFile" :headers="requestHeader" accept=".xlsx,.xls,.excel" :show-upload-list="false" :action="action" :data="importData">
			      <Button icon="md-add" type="primary" size="default" class="toolbar-btn">导入数据</Button>
			  </Upload> -->
	      </Row>
	  </Form>
      <div class="table_body" >
        <Table
            ref="table"
            border
            :loading="loading"
            :columns="columns"
            :no-data-text="NoDatas"
            :data="tableBody_item"
          ></Table>

         <div style="margin-top: 10px;">
            <Page
               show-sizer show-elevator
              show-total
              :current="current"
              :total="totalCount"
              @on-change="pageChange"
              @on-page-size-change="pagesizeChange"
            ></Page>
        </div>
      </div>
    </Card>
    <!-- 新增/编辑弹出框 -->
     <newdate-table :value="testModal" :type='modelType' @close="close" ref="newID"></newdate-table>
     <!-- 导入 -->
     <date-import :value="testDate"  @close="closeDate" ref="importDay"></date-import>
     <!-- 操作日志弹出框 -->
     <operation :value="testLog"  @close="closeLog" ref="logID"></operation>
     <!-- 清空 -->
     <deleteImport :value="showDelete"  @close="closeDate" ref="deleteImport"></deleteImport>
     <imports :value="showImport"  @close="closeDate" ref="Import"></imports>
     
  </div>
</template>
<script>
import Util from '../../../lib/util';
import moment from "moment";
import newdateTable from './newdateTable.vue'
import dateImport from './dateImport.vue'
import deleteImport from './delete.vue'
import imports from './imports.vue'
import operation from './operation.vue'
export default {
  name:'personholiday',
  props: {},
  components:{
    newdateTable,
    dateImport,
	deleteImport,
	imports,
    operation
  },
  filters: {
    formData(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      totalCount:0, //总共多少页
	    current:1, //当前第几页
      testModal:false,
      testDate:false,
	  showDelete:false,
	  showImport:false,
      testLog:false,
	  isAdmin:false,
      form: {
        "Post": null,
		"month":"",
		"year":"",
        "SkipCount": 0,  //从第几条开始爬
        "MaxResultCount": 10,  //一页多少条
      },
      NoDatas: "暂无数据",
	  action: this.$constDefinition.baseUrl + '/Leavefile/Upload',
	  spinShow: false,
	  importData: {},
	  requestHeader: {
	      Authorization: `Bearer ${Util.abp.auth.getToken()}`,
	  },
      loading: false,
      columns: [],
	  postList:[],
      tableBody_item: [],
      fromFields: {},
      modelType: '新增'

    };
  },
  mounted() {
	this.getUserSelectList();
	this.changeDates()
    this.getColumns(); //列表数据初始化
  },
  methods: {
	 changeDates() {
	   this.form.month = this.$moment(this.form.Month).format("MM") 
	   this.form.year = this.$moment(this.form.Month).format("YYYY") 
	 },
	 //时间转换
	 changeDate(fmtDate,date,type) {
	 		  // console.log(this.$moment(this.form[type]).format("MM") );
	 		  // console.log(this.$moment(this.form.year).format("yyyy") );
	   this.form[type] = fmtDate//this.$moment(this.form.month).format("MM") 
	 		console.log(this.form);
	  //  this.form.year = this.$moment(this.form.year).format("yyyy") 
	 },
	  //获取下拉框
	  async getUserSelectList() {
	    const { data } = await this.$Ajax.get(
	      '/api/services/app/PostWorkdaySetting/GetPostWorkInitData'
	    )
	    this.postList = data.result.postList
	    this.isAdmin = data.result.isAdmin
		this.form.Post=1;
		console.log(this.form);
		this.getData() //获取列表数据
	  },
    //页数
    pageChange(size){
    this.form.SkipCount = (size-1)*this.form.MaxResultCount;
		this.getData()
    },
    //每页最大条数
    pagesizeChange(size){
      this.form.MaxResultCount = size
      this.getData()
    },
	reset() {
            // 清空所有属性值
            Object.keys(this.form).forEach(key => (this.form[key] = ''));
			this.form.Post=1;
			this.changeDates()
            // this.rangeTime = [];
        },
    //列表数据
    async getData() {
      this.loading = true 
      let findData = await this.$Ajax.get(`/api/services/app/PostWorkdaySetting/GetAll`,{params:this.form});
      this.tableBody_item = findData.data.result.items
      this.totalCount = findData.data.result.totalCount;
      this.loading = false
    },
    //下拉框数据
    async indicatorData() { 
    let indicatorTable = await this.$Ajax.get("/api/services/app/Indicator/GetInitData");
    this.fromFields = indicatorTable.data.result
    },
	// 下载导入模板
	downLoadTemplate() {
	    this.downloadFile('/Leavefile/DownloadModel_PostWorkdaySetting', '导入岗位工作日模板');
	},
	downloadFile(url, title) {
	    const date = moment(new Date()).format('yyyyMMDDHHmm');
	    let _this = this;
	    let consturl = this.$constDefinition.baseUrl + url; //下载地址url
	    var xhr = new XMLHttpRequest();
	    xhr.open('get', consturl, true); // get、post都可
	    xhr.responseType = 'blob';
	    xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`); //加请求头
	    xhr.onload = function () {
	        console.log(xhr);
	        if (xhr.status == 200) {
	            let blob = new Blob([this.response], {
	                type: 'application/vnd.ms-excel',
	            });
	            var a = document.createElement('a');
	            var url = window.URL.createObjectURL(blob);
	            a.href = url;
	            a.download = title + date + '.xlsx'; // 文件名
	            if (xhr.readyState === 4) {
	                _this.$Message.success({
	                    content: '下载成功',
	                    duration:3
	                });
	            }
	        } else {
	            _this.$Message.error({
	                content: '下载失败',
	                duration:3
	            });
	        }
	        a.click();
	        window.URL.revokeObjectURL(url);
	    };
	    xhr.send();
	},
    //新增 
    listTest(type,data){
      this.modelType = type
      this.testModal = true;
      if(type=="编辑"){
        this.$refs.newID.getInforID(data.id)
      }
    },
    //关闭新增编辑弹出框
    close(data){
		this.testModal = false;
		if(data.cancel){
			this.getData();
		}
  },
  //下载模板
			down(e){
				window.open(abp.url+e)
			},
  //人员假期导入
    importT(){
  				this.testDate = true;
  				// this.$refs.uploads.clearn();
    },
	deleteImport(){
		this.showDelete=true;
		console.log(this.showDelete,"点击");
	},
	shoImport(){
		this.showImport=true;
	},
    closeDate(){
      this.testDate = false;
	  this.showDelete = false;
	  this.showImport=false;
      this.form.skipCount = 0;
      this.getData();
    },
  // 导入前处理
  beforeImportFile() {
      this.spinShow = true;
  },
  // 导入成功
  importFile() {
      this.$Message.success({
          content: '导入成功',
          duration: 3,
      });
      this.getData();
      this.spinShow = false;
  },
  // 导入失败
  errorImportFile(error, file, fileList) {
      this.$Message.error({
          content: file.error.message,
          duration: 3,
      });
      this.getData();
      this.spinShow = false;
  },

    //打开日志弹出框
    openLog(type,data){
      this.testLog = true;
      this.$refs.logID.getLogID(data.id)
      
    },
    //关闭关闭弹出框
    closeLog(data){
		this.testLog = false;
		},

    //table 列
    getColumns() {
      this.columns = [
        {
          title: "岗位",
          key: "postText",
        },
        {
          title: "时间",
          key: "workDateText",
        },
        {
          title: "是否工作日",
		  key: "isWorkday",
		  render: (h , params) => {
		    return h('span', params.row.isWorkday ? "是" : "否")
		  }
        },
        {
          title: "假期描述",
          key: "leaveDescription",
        },
      ];
    },
  
  },
};
</script>

<style lang="less" scoped="scoped">
.app{
min-width: 900px;

}
.ivu-upload {
    display: inline-block;
}
</style>
